import z from 'zod';
import { deviationsReportSchema } from './transportExecution.reportDeviations.schema';

const historyEntryTypeSchema = z.enum([
    'PICKUP_CONFIRMED',
    'SHIPMENT_HANDOVER',
    'SHIPMENT_TAKEOVER',
    'TRANSPORT_ORDERED',
    'TRANSPORT_CONFIRMED',
    'TRANSFER_WITH_DISCREPANCY',
    'DEPARTED',
    'IN_TRANSIT',
    'ARRIVED_AT_GATE',
]);

const actorRoleSchema = z.enum(['CONSIGNEE', 'CROSS_DOCK', 'FREIGHT_FORWARDER', 'CONSIGNOR']);

const externalActorRoleSchema = z.enum(['CONSIGNEE', 'CROSS_DOCK', 'FREIGHT_FORWARDER']);

const shipmentHistoryReportedBySchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('INTERNAL'),
        role: actorRoleSchema,
        duns: z.string(),
        name: z.string().optional(),
    }),
    z.object({
        type: z.literal('EXTERNAL'),
        supplier_code: z.string(),
        duns: z.string().optional(),
        role: externalActorRoleSchema.optional(),
    }),
]);

const shipmentHistoryAddressSchema = z.object({
    city: z.string(),
    postal_code: z.string(),
    country_code: z.string(),
});

const shipmentHistoryPartySchema = z.object({
    role: actorRoleSchema,
    name: z.string().optional(),
    address: shipmentHistoryAddressSchema.optional(),
});

const shipmentHistoryStatusLocationSchema = z.union([
    z.object({
        physical_location: z.object({
            name: z.string(),
            city: z.string(),
            country_code: z.string(),
        }),
    }),
    z.object({ duns: z.string() }),
]);

const shipmentHistoryDocumentSchema = z.object({
    document_id: z.uuid(),
    file_name: z.string(),
});

const shipmentHistoryEntrySchema = z.object({
    type: historyEntryTypeSchema,
    occurred_at: z.iso.datetime(),
    reported_by: shipmentHistoryReportedBySchema,
    deviations_report: deviationsReportSchema.optional(),
    status_location: shipmentHistoryStatusLocationSchema.optional(),
    documents: z.array(shipmentHistoryDocumentSchema).optional(),
    loading: shipmentHistoryPartySchema.optional(),
    unloading: shipmentHistoryPartySchema.optional(),
    freight_forwarder: shipmentHistoryPartySchema.optional(),
});

export const getShipmentHistoryResponseSchema = z.object({
    items: z.array(shipmentHistoryEntrySchema),
});

export const shipmentHistoryDocumentDownloadResponseSchema = z.object({
    url: z.url(),
});

export type ApiGetShipmentsHistoryResponse = z.infer<typeof getShipmentHistoryResponseSchema>;
export type ApiShipmentHistoryEntry = z.infer<typeof shipmentHistoryEntrySchema>;
export type ApiShipmentHistoryDocumentDownloadResponse = z.infer<typeof shipmentHistoryDocumentDownloadResponseSchema>;
